// extracted by mini-css-extract-plugin
module.exports = {"container":"_3wO4M8aP6ZlZq5PBN5zVvA","icon":"_4pOCDu1F3w28FqnSTrer1"};